/**
 * ✅ 执行标签筛选
 */
export const EXECUTE_FILTER_SPACES_BY_TAG = 'Execute Filter Spaces By Tag';
/**
 * ✅ 执行排序
 */
export const EXECUTE_SORT_SPACES = 'Execute Sort Spaces';
/**
 * ✅ 切换工作空间宫格/列表视图
 */
export const TOGGLE_SPACES_VIEW = 'Toggle Spaces View';
/**
 * ✅ 执行置顶工作空间操作
 */
export const EXECUTE_PIN_SPACE = 'Execute Pin Space';
/**
 * ✅ 执行取消置顶工作空间操作
 */
export const EXECUTE_UNPIN_SPACE = 'Execute Unpin Space';
/**
 * ✅ 执行导入工作空间操作
 */
export const EXECUTE_IMPORT_SPACE = 'Execute Import Space';
/**
 * ✅ 点击导航库按钮
 */
export const CLICK_NAVIGATE_TO_MARKETPLACE = 'Click Navigate To Marketplace';
/**
 * ✅ 点击搜索框结果列表的 Tab
 */
export const CLICK_SEARCH_RESULT_TAB = 'Click Search Result Tab';
/**
 * ✅ 打开工作空间操作菜单
 */
export const OPEN_SPACE_ACTION_MENU = 'Open Space Action Menu';
/**
 * ✅ 预览自定义字段
 */
export const PREVIEW_CUSTOM_FIELDS = 'Preview Custom Fields';
/**
 * ✅ 点击 AI 提效工具
 */
export const CLICK_SPACE_AI_TOOL = 'Click Space AI Tool';
/**
 * ✅ 点击最近访问工作空间
 */
export const CLICK_RECENTLY_VISITED_SPACE = 'Click Recently Visited Space';
